<template>
    <div>
           <img
                     @click="
                       openInNewTab(
                         'https://www.peresourcesbank.co.uk/'
                       )
                     "
                     class="w-5/12 p-4"
                     src="/static/images/peresourcesbank.png"
                     alt=""
                   />
   
                   <div class="p-5">
                     <h5
                       class="mb-2 text-lg font-bold tracking-tight text-gray-700 dark:text-white"
                     >
                     PE Resources Bank
                     </h5>
   
                     <div
                       class="mb-3 font-normal text-gray-700 dark:text-gray-400"
                     >
                       <p>
                        PE Resources Bank aims to provide high quality teaching materials for staff to use and promote a genuine love for learning.<br/>
                        PE Resources Bank is among the leading suppliers of Physical Education resources providing resources for Physical Education Teachers - GCSE, Vocational, A Level, Schemes of Work and more!                       </p>
                     
                     </div>
   
                     <div
                       @click="
                         openInNewTab(
                           'https://www.peresourcesbank.co.uk/'
                         )
                       "
                       class="link cursor-pointer focus:ring-4 focus:outline-none focus:ring-blue-300"
                     >
                       Read more (external link)
                       <i
                         class="fas fa-caret-right ml-3 text-base text-action-blue"
                       ></i>
                     </div>
                     <br />
   
                     <div
                       @click="
                         openInNewTab('https://shop.primarypepassport.co.uk/')
                       "
                       class="link cursor-pointer text-green-600 focus:ring-4 focus:outline-none focus:ring-blue-300"
                     >
                       Purchase add on curriculum (external link)
                       <i
                         class="fas fa-caret-right ml-3 text-base text-action-blue"
                       ></i>
                     </div>
                   </div>
       </div>
   </template>
   <script>
       export default{
           name: "AdvertResourceBank",
   
           methods: {
   
   openInNewTab(url) {
     window.open(url, '_blank');
   },
   },
       }
   
   </script>
   <style scoped>
   
   </style>